export const CLIENT_TYPES = {
  WEB: 'web',
  MOBILE: 'mobile',
  TABLET: 'tablet',
};

export const USER_TYPES = {
  EMPLOYEE: 'Employee',
  DEPENDENT: 'Dependent',
  INSURER: 'Insurer',
  CLIENT: 'Client',
  BROKER: 'Broker',
  MEMBER: 'Member',
  PROVIDER: 'Provider',
};

//find provider
export const MAXIMUM_FIND_PROVIDER_RADIUS = 20;

//price comparison
export const MAXIMUM_FIND_PRICE_COMPARE_RADIUS = 5; //Pushpa Requested On DEMO CALL 1/5/2024

export const DEFAULT_FIND_PROVIDER_RADIUS = 20;

//Types of Claims Master Data
export const CLAIM_TYPES = [
  'All claims',
  'Last claims',
  //'Processing',
  //'Approved',
  //'Denied',
  //'Paid',
  //'Need Attention',
  //'Denied1',
  //'Paid1',
  //'Need Attention1'
];

//Send Email

export const EMAIL = {
  USER_EMAIL: 'aditi.deshmukh1@mphasis.com',
  USER_NAME: 'Aditi Deshmukh',
  ADDRESS_CC: '',
  ADDRESS_BCC: '',
};

//Pagination no of pages
export const DISPLAY_OPTIONS = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

export const AuditButtonOptions = [
  { label: 'Recent Activities', type: 'viewRecentActivities' },
  { label: 'View All Activities', type: 'viewAllActivities' },
];

//Configure Links
//contacts
export const COLUMNS = [
  {
    field: 'Public',
    label: 'Public',
    sort: 'asc',
  },
  {
    field: 'Secured',
    label: 'Secured',
    sort: 'asc',
  },
  {
    field: 'Type',
    label: 'Type',
    sort: 'asc',
  },
  {
    field: 'Title',
    label: 'Title',
    sort: 'asc',
  },
  {
    field: 'Block',
    label: 'Block',
    sort: 'asc',
  },
  {
    field: 'Actions',
    label: 'Actions',
  },
];

//Configure pages Richtext Editor
export const TOOL_BAR_CONFIG = {
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'BLOCK_TYPE_DROPDOWN',
    'HISTORY_BUTTONS',
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal', style: 'unstyled' },
    { label: 'Heading Large', style: 'header-one' },
    { label: 'Heading Medium', style: 'header-two' },
    { label: 'Heading Small', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' },
  ],
};
//Configure resource
export const USER_TYPE_HIERARCHY_MAP = {
  Insurer: 'BLOB',
  Client: 'EMPLOYER',
};

export const RESOURCE_COLUMNS = [
  {
    field: 'DisplayOnDashboard',
    label: 'Display on Dashboard',
    sort: 'asc',
  },
  {
    field: 'Type',
    label: 'Type',
    sort: 'asc',
  },
  {
    field: 'ResourceTitle',
    label: 'Resource Title',
    sort: 'asc',
  },
  {
    field: 'ResourceGroup',
    label: 'Resource Group',
    sort: 'asc',
  },
  {
    field: 'Actions',
    label: 'Actions',
  },
];

//Configure social media
export const ALL_DATA = [
  {
    OID: '',
    MediaType: 'Facebook',
    URL: '',
  },
  {
    OID: '',
    MediaType: 'YouTube',
    URL: '',
  },
  {
    OID: '',
    MediaType: 'LinkedIn',
    URL: '',
  },
  {
    OID: '',
    MediaType: 'Twitter',
    URL: '',
  },
  {
    OID: '',
    MediaType: 'Mobile App - Google Play Store',
    URL: '',
  },
  {
    OID: '',
    MediaType: 'Mobile App - Apple App Store',
    URL: '',
  },
];

//Contact column
export const CONTACT_COLUMNS = [
  {
    field: 'Public',
    label: 'Public',
    sort: 'asc',
  },
  {
    field: 'Secured',
    label: 'Secured',
    sort: 'asc',
  },
  {
    field: 'Type',
    label: 'Email',
    sort: 'asc',
  },
  {
    field: 'Address',
    label: 'Address',
    sort: 'asc',
  },
  {
    field: 'Actions',
    label: 'Actions',
  },
];

//Permission group info from
export const USER_TYPE_OPTIONS = [
  //{ label: 'Insurer', value: 'Insurer' },
  //{ label: 'Employer', value: 'Client' },
  { label: 'Employee', value: 'Employee' },
  { label: 'Dependent', value: 'Dependent' },
];

//preference suppress fields
export const OPTIONS = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
  { label: 12, value: 12 },
  { label: 13, value: 13 },
  { label: 14, value: 14 },
  { label: 15, value: 15 },
  { label: 'Hide', value: 'hide' },
];

//preferences time zone and date format
export const TIME_ZONE_OPTIONS = [
  {
    label: 'Eastern Standard Time (EST)',
    value: 'Eastern Standard Time (EST)',
  },
  {
    label: 'Central Standard Time (CST) (UTC-6)',
    value: 'Central Standard Time (CST) (UTC-6)',
  },
];
export const DATE_FORMAT_OPTIONS = [
  { label: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
  { label: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
  { label: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
];

//user group usergroup duplicate
export const TREEDATA = [
  {
    title: 'Claims',
    key: '0-2',
    children: [
      {
        title: 'View Claims',
        key: '0-2-1',
      },
      {
        title: 'Create Claims',
        key: '0-2-2',
      },
      {
        title: 'Search Claims',
        key: '0-2-3',
      },
    ],
  },
  {
    title: 'Members',
    key: '0-1',
    children: [
      {
        title: 'View Members',
        key: '0-1-5',
      },
      {
        title: 'Create Members',
        key: '0-1-2',
      },
      {
        title: 'Search Members',
        key: '0-0-1',
        children: [
          {
            title: 'Search by SSN',
            key: '0-1-1',
          },
        ],
      },
      {
        title: 'Delete Members',
        key: '0-1-4',
      },
    ],
  },
  {
    title: 'Dependent',
    key: '0-4',
    children: [
      {
        title: 'View Dependent',
        key: '0-4-1',
      },
      {
        title: 'Create Dependent',
        key: '0-4-2',
      },
    ],
  },
  {
    title: 'Permission Group',
    key: '0-5',
    children: [
      {
        title: 'Permission',
        key: '0-5-1',
      },
    ],
  },
];

//view member account details filter

export const TABLE_HEADER = [
  { header: 'Transaction Date', dataKey: 'ProcessedDate' },
  { header: 'Description  ', dataKey: 'Description' },
  { header: 'Claim Number', dataKey: 'ClaimNumber' },
  { header: 'Deposits', dataKey: 'Deposit' },
  { header: 'Withdrawals', dataKey: 'Withdrawl' },
  { header: 'Balance', dataKey: 'Balance' },
  { header: 'Status', dataKey: 'Status' },
];
//Claims filter
export const DATE_SELECTIONS_OPTIONS = [
  //{ label: 'Year-to-Date', value: '' },
  { label: 'Last 1 Month', value: '1' },
  { label: 'Last 3 Months', value: '3' },
  { label: 'Last 6 Months', value: '6' },
  { label: 'Last One Year', value: '12' },
  { label: 'Date Range', value: 'Date Range' },
];
//patients Rights
export const PATIENTS_RIGHTS_COLUMN = [
  {
    field: 'name',
    label: 'Name',
    sort: 'disabled',
  },
  {
    field: 'relationship',
    label: 'Relationship',
    sort: 'disabled',
  },
];

export const PROVIDER_OPTIONS = [
  { label: 'Facilities', value: 'facility' },
  { label: 'Doctors', value: 'doctor' },
];

//Find provider
export const GENDER_OPTIONS = [
  { label: 'Any', value: '' },
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Other', value: 'Unknown' },
];

export const DISTANCE_OPTIONS = [
  { label: 'Within 5 Miles', value: 5 },
  { label: 'Within 10 Miles', value: 10 },
  { label: 'Within 15 Miles', value: 15 },
  { label: 'Within 20 Miles', value: 20 },
  { label: 'Within 50 Miles', value: 50 },
  { label: '<= 100 Miles', value: 100 },
];

//Distance Options for specific Price Comparison
export const PC_DISTANCE_OPTIONS = [
  { label: 'Within 5 Miles', value: 5 },
  { label: 'Within 10 Miles', value: 10 },
  { label: 'Within 15 Miles', value: 15 },
  { label: 'Within 20 Miles', value: 20 },
  { label: 'Within 50 Miles', value: 50 },
  { label: '<= 100 Miles', value: 100 },
];

export const LANGUAGE_OPTIONS = [
  { label: 'English', value: 'English' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'French', value: 'French' },
  { label: 'German', value: 'German' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Spanish', value: 'Spanish' },
];

export const SPECIALTIES_OPTIONS = [
  {
    label: 'Primary Care - Family Practice',
    value: 'Primary Care - Family Practice',
  },
  { label: 'Family Nurse Practitioner', value: 'Family Nurse Practitioner' },
  {
    label: 'Primary Care - Internal Medicine',
    value: 'Primary Care - Internal Medicine',
  },
  { label: 'Primary Care - Pediatrics', value: 'Primary Care - Pediatrics' },
  {
    label: 'Primay Care - Sports Medicine',
    value: 'Primay Care - Sports Medicine',
  },
];

export const FACILITY_OPTIONS = [
  { label: 'General Hospital', value: 'General Hospital' },
  {
    label: 'Acute care and General Hospital',
    value: 'Acute care and General Hospital',
  },
  {
    label: 'California General Hospital',
    value: 'California General Hospital',
  },
  {
    label: 'Genera and Critical Care Hospital',
    value: 'Genera and Critical Care Hospital',
  },
  { label: 'General Test Lab', value: 'General Test Lab' },
  { label: 'General Nursing Facilities', value: 'General Nursing Facilities' },
];

export const PROVIDER_SERVICES_OPTIONS = [
  {
    label: 'Accepting New Patients',
    value: 'Accepting New Patients',
    key: 'AcceptingNewPatients',
  },
];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTHS_KEY_VALUE = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
];

export const CONTENT_PAGE_TITLES = {
  regPrivacyPolicy: 'Privacy Policy',
  regDisclaimer: 'Disclaimer',
  regTermsAndConditions: 'Terms and Conditions',
};

export const SKIPPED_URLS_401 = [
  '/authorization/login/portal',
  '/client/getclientsconfiguration/',
  '/enumeration/verifyaccountunlocklinkexpiry',
  '/user/updateuser',
];

export const USE_PERSONA_FRAMEWORK = true;

export const PORTAL_NAMES = {
  JAVELINA: {
    DEFAULT: 'A1M Benefits',
    INSURER: 'For Insurers',
    BROKER: 'For Brokers',
    EMPLOYER: 'For Employers',
    CLIENT: 'For Employers',
    PROVIDER: 'For Providers',
    EMPLOYEE: 'For Members',
    DEPENDENT: 'For Members',
  },
  BYWATER: {
    DEFAULT: 'Bywater Benefits',
    INSURER: 'For Insurers',
    BROKER: 'For Brokers',
    EMPLOYER: 'For Employers',
    CLIENT: 'For Employers',
    PROVIDER: 'For Providers',
    EMPLOYEE: 'For Members',
    DEPENDENT: 'For Members',
  },
  KEENAN: {
    DEFAULT: 'Keenan TPA Benefit Access',
    INSURER: 'For Insurers',
    BROKER: 'For Brokers',
    CLIENT: 'For Employers',
    EMPLOYER: 'For Employers',
    PROVIDER: 'For Providers',
    EMPLOYEE: 'For Members',
    DEPENDENT: 'For Members',
  },
  HUB: {
    DEFAULT: 'HUB International',
    INSURER: 'For Insurers',
    BROKER: 'For Brokers',
    CLIENT: 'For Employers',
    EMPLOYER: 'For Employers',
    PROVIDER: 'For Providers',
    EMPLOYEE: 'For Members',
    DEPENDENT: 'For Members',
  },
};

export const PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD = {
  time_in_seconds: 30,
  clicks: 10,
};

export const SelfAccountUnlockFormFields = [
  { label: 'First Name', value: 'fname' },
  { label: 'Last Name', value: 'lname' },
  { label: 'SSN', value: 'ssn' },
  { label: 'Date of Birth', value: 'dob' },
  { label: 'Alternate ID 1', value: 'altid1' },
  { label: 'Alternate ID 2', value: 'altid2' },
  { label: 'Certificate Number', value: 'certificatenumber' },
  { label: 'Medicare ID', value: 'medicareid' },
  { label: 'Postal Code', value: 'postalcode' },
  { label: 'Relationship (Only for Dependents)', value: 'relationship' },
  { label: 'Alternate Email', value: 'altemail' },
  { label: 'Phone Number', value: 'phonenumber' },
];

export const UNLOCK_ACCOUNT_FIELD_CONFIG = {
  Email: {
    name: 'email',
    label: 'Registered Email',
    type: 'email',
  },
  FirstName: {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
  },
  LastName: {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
  },
  DateOfBirth: {
    name: 'dateOfBirth',
    label: 'Date Of Birth',
    type: 'date',
  },
  PhoneNumber: {
    name: 'phoneNumber',
    label: 'Phone Number',
    type: 'text',
  },
  SocialSecurityNumber: {
    name: 'ssn',
    label: 'Social Security Number',
    type: 'text',
  },
  PostalCode: {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
  },
  Relationship: {
    name: 'relationship',
    label: 'Relationship',
    type: 'text',
  },
  CertificateNumber: {
    name: 'certificateNumber',
    label: 'Certificate Number',
    type: 'text',
  },
  AlternateID1: {
    name: 'alternateId1',
    label: 'Alternate ID 1',
    type: 'text',
  },
  AlternateID2: {
    name: 'alternateId2',
    label: 'Alternate ID 2',
    type: 'text',
  },
  MedicareID: {
    name: 'medicareId',
    label: 'Medicare ID',
    type: 'text',
  },
};
